import CrearCotizacion from './CrearCotizacion'

export default CrearCotizacion
